// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list_template_div[data-v-0e7282f8]{width:49%;float:left}.md-ripple>span[data-v-0e7282f8]{position:relative}.delete-icon[data-v-0e7282f8]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
